/* =============================================================
   LISTICLE ADVERTORIAL — listicle.js
   1. Sticky bar: hides when the inline CTA is on screen
   2. Urgency ticker: duplicate nodes for seamless loop
   ============================================================= */

(function () {
  'use strict';

  /* ── Sticky bar ─────────────────────────────────────────── */
  function initStickyBar() {
    var bar    = document.querySelector('.lp-sticky-bar');
    var anchor = document.querySelector('.lp-sticky-bar__anchor');

    if (!bar) return;

    if (anchor && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.5 });
      obs.observe(anchor);
    }
  }

  /* ── Urgency ticker ─────────────────────────────────────── */
  function initTicker() {
    var track = document.querySelector('.lp-urgency__track');
    if (!track) return;

    // Duplicate children so the loop is seamless
    var original = track.innerHTML;
    track.innerHTML = original + original;
    track.classList.add('lp-urgency__track--animated');
  }

  /* ── Review scroller — calculate scroll distance per column ── */
  function initReviewScroller() {
    var cols = document.querySelectorAll('.lp-reviews__col');
    if (!cols.length) return;

    cols.forEach(function (col) {
      // Each column contains 2× its content (duplicated in Liquid).
      // Scroll distance = half the total scrollHeight (one full set).
      var distance = col.scrollHeight / 2;
      col.style.setProperty('--scroll-distance', '-' + distance + 'px');
    });
  }

  /* ── Lazy-load videos when they scroll into view ─────── */
  function initLazyVideos() {
    var videos = document.querySelectorAll('.lp-lazy-video');
    if (!videos.length || !('IntersectionObserver' in window)) {
      videos.forEach(function (v) { loadVideo(v); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });
    videos.forEach(function (v) { obs.observe(v); });
  }

  function loadVideo(video) {
    var count = parseInt(video.getAttribute('data-source-count'), 10) || 0;
    for (var i = 1; i <= count; i++) {
      var src = video.getAttribute('data-src-' + i);
      var type = video.getAttribute('data-type-' + i);
      if (src) {
        var source = document.createElement('source');
        source.src = src;
        if (type) source.type = type;
        video.appendChild(source);
      }
    }
    video.load();
    video.play().catch(function () {});
  }

  /* ── Boot ───────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyBar();
      initTicker();
      initReviewScroller();
      initLazyVideos();
    });
  } else {
    initStickyBar();
    initTicker();
    initReviewScroller();
    initLazyVideos();
  }
})();


/* =============================================================
   PDP GALLERY — slide nav + thumbnails + touch swipe
   ============================================================= */
(function () {
  'use strict';

  function initGallery() {
    var slidesWrap = document.getElementById('lp-slides');
    if (!slidesWrap) return;

    var slides    = slidesWrap.querySelectorAll('.lp-pdp__slide');
    var thumbsEl  = document.getElementById('lp-thumbs');
    var thumbs    = thumbsEl ? thumbsEl.querySelectorAll('.lp-pdp__thumb') : [];
    var curEl     = document.getElementById('lp-cur');
    var prevBtn   = document.getElementById('lp-prev');
    var nextBtn   = document.getElementById('lp-next');
    var total     = slides.length;
    var cur       = 0;

    if (total < 2) return;

    function goTo(idx) {
      if (slides[cur]) {
        slides[cur].classList.remove('is-active');
        slides[cur].setAttribute('aria-hidden', 'true');
      }
      if (thumbs[cur]) thumbs[cur].classList.remove('is-active');

      cur = ((idx % total) + total) % total;

      if (slides[cur]) {
        slides[cur].classList.add('is-active');
        slides[cur].setAttribute('aria-hidden', 'false');
      }
      if (thumbs[cur]) {
        thumbs[cur].classList.add('is-active');
        thumbs[cur].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      if (curEl) curEl.textContent = cur + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); });

    if (thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(this.dataset.index, 10));
        });
      });
    }

    // Touch swipe on slides
    var touchStartX = 0;
    slidesWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    slidesWrap.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? cur + 1 : cur - 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();


/* =============================================================
   BUNDLE CHOOSER — select offer, update variant ID + price
   ============================================================= */
(function () {
  'use strict';

  function initBundleChooser() {
    var bundles      = document.querySelectorAll('.lp-pdp__bundle');
    var vidInput     = document.getElementById('lp-pdp-vid');
    var priceEl      = document.getElementById('lp-atc-price');
    var bundleNameEl = document.getElementById('lp-bundle-name');

    if (!bundles.length) return;

    function selectBundle(el) {
      bundles.forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
      el.classList.add('is-selected');
      el.setAttribute('aria-checked', 'true');

      if (vidInput && el.dataset.variantId) vidInput.value = el.dataset.variantId;
      if (priceEl  && el.dataset.price)     priceEl.textContent  = el.dataset.price;
      if (bundleNameEl && el.dataset.bundleName) bundleNameEl.textContent = el.dataset.bundleName;
    }

    bundles.forEach(function (bundle) {
      bundle.addEventListener('click', function () { selectBundle(this); });
      bundle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectBundle(this); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleChooser);
  } else {
    initBundleChooser();
  }
})();


/* =============================================================
   VARIANT SELECTORS — size & color buttons update hidden input
   ============================================================= */
(function () {
  'use strict';

  function initVariantSelectors() {
    var sizeColorBtns  = document.querySelectorAll('.lp-pdp__size-btn, .lp-pdp__color-btn');
    var vidInput       = document.getElementById('lp-pdp-vid');
    var variantsScript = document.getElementById('lp-variants-json');

    if (!sizeColorBtns.length) return;

    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { /* ignore */ }
    }

    // Collect current selected values by option index
    var selectedOptions = {};
    document.querySelectorAll('.lp-pdp__step-value[data-option-idx]').forEach(function (el) {
      selectedOptions[el.dataset.optionIdx] = el.textContent.trim();
    });

    function findMatchingVariant() {
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (idx) {
          var optNum = parseInt(idx, 10) + 1; // option1, option2, option3
          return v['option' + optNum] === selectedOptions[idx];
        });
      });
    }

    sizeColorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optIdx = this.dataset.optionIndex;
        var val    = this.dataset.optionValue;

        // Deselect siblings in same option group
        document.querySelectorAll('[data-option-index="' + optIdx + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        this.classList.add('is-selected');

        // Update label
        var labelEl = document.querySelector('.lp-pdp__step-value[data-option-idx="' + optIdx + '"]');
        if (labelEl) labelEl.textContent = val;

        // Update selection map
        selectedOptions[optIdx] = val;

        // Only update variant ID if no bundle is explicitly selected
        var activeBundleVid = null;
        var selBundle = document.querySelector('.lp-pdp__bundle.is-selected');
        if (selBundle) activeBundleVid = selBundle.dataset.variantId || '';

        if (!activeBundleVid && vidInput && variants.length) {
          var match = findMatchingVariant();
          if (match) {
            vidInput.value = match.id;
            var priceEl = document.getElementById('lp-atc-price');
            if (priceEl && match.price) {
              // Shopify prices are in cents; format as currency
              var formatted = (match.price / 100).toLocaleString('en-US', {
                style: 'currency', currency: 'USD'
              });
              priceEl.textContent = formatted;
            }
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSelectors);
  } else {
    initVariantSelectors();
  }
})();


/* =============================================================
   FAQ ROTATOR — auto-advances question pills every 3 s
   ============================================================= */
(function () {
  'use strict';

  function initFaqRotator() {
    var btns = document.querySelectorAll('.lp-pdp-rotator__btn');
    if (btns.length < 2) return;

    var cur      = 0;
    var interval = setInterval(advance, 3000);

    function setActive(idx) {
      btns.forEach(function (b) { b.classList.remove('is-active'); });
      if (!btns[idx]) return;
      btns[idx].classList.add('is-active');
      btns[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function advance() {
      cur = (cur + 1) % btns.length;
      setActive(cur);
    }

    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        clearInterval(interval);
        cur = i;
        setActive(i);
        interval = setInterval(advance, 3000);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqRotator);
  } else {
    initFaqRotator();
  }
})();
